import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveSchool } from 'actions/user';
import { Icon, ActionSheet, TooltipMenu } from '@haldor/ui';
import './_device.scss';

var DeviceHeader = /*#__PURE__*/function (_Component) {
  _inherits(DeviceHeader, _Component);

  var _super = _createSuper(DeviceHeader);

  function DeviceHeader() {
    var _this;

    _classCallCheck(this, DeviceHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isIndex", function () {
      return window.location.pathname == '/';
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function (event) {
      event.preventDefault();
      window.history.go(-1);
    });

    _defineProperty(_assertThisInitialized(_this), "getBadgeForSchool", function (school) {
      var activeSchool = _this.props.activeSchool;

      if (_this.props.userUnread == null || school.id == activeSchool) {
        return null;
      }

      return _this.props.userUnread.reduce(function (value, item) {
        if ((item.schoolId == 0 || item.schoolId == school.id) && item.type == 'CONVERSATION') {
          if (value == null) value = 0;
          return value += item.unread;
        }

        return value;
      }, null);
    });

    _defineProperty(_assertThisInitialized(_this), "getBadgeForItem", function () {
      if (_this.props.userUnread == null) {
        return null;
      }

      var activeSchool = _this.props.activeSchool;
      return _this.props.userUnread.reduce(function (value, item) {
        if (item.schoolId == activeSchool && item.type != 'CONVERSATION') {
          return value;
        }

        if (value == null) value = 0;
        return value += item.unread;
      }, null);
    });

    _defineProperty(_assertThisInitialized(_this), "selectSchool", function () {
      var user = _this.props.user;
      var schools = user.schools.map(function (school) {
        return {
          label: /*#__PURE__*/React.createElement("div", null, _this.getBadgeForSchool(school) != null ? /*#__PURE__*/React.createElement("div", {
            className: "badge",
            style: {
              display: 'inline-flex',
              justifyContent: 'center',
              transform: 'none',
              borderRadius: '100%',
              position: 'static',
              marginRight: '.4rem'
            }
          }, _this.getBadgeForSchool(school)) : null, school.title),
          value: school.id
        };
      });
      ActionSheet.prompt({
        items: schools
      }).then(function (school) {
        localStorage.setItem("hal.school" + user.id, school);

        _this.props.setActiveSchool(school);

        _this.props.history.push("/switch");
      })["catch"](function () {
        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAction", function (action) {
      return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: action.onClick
      }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
        name: action.icon
      }) : null, action.value);
    });

    return _this;
  }

  _createClass(DeviceHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var school = this.props.user.schools.find(function (school) {
        return school.id === _this2.props.activeSchool;
      });

      if (window.location.pathname == '/menu') {
        // Dont show header if on menu page
        return null;
      }

      var actionTrigger = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        name: "Bullets"
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "device-menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left"
      }, this.props.settings.backButton ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.goBack,
        className: "c--button back"
      }, /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          transform: 'rotate(90deg)'
        },
        className: "a-90"
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })))) : null), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.isIndex() ? /*#__PURE__*/React.createElement("div", {
        onClick: this.selectSchool
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, this.getBadgeForItem() != null ? /*#__PURE__*/React.createElement("span", {
        className: "badge",
        style: {
          justifyContent: 'center'
        }
      }, this.getBadgeForItem()) : null, school.title), /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      })) : this.props.title), /*#__PURE__*/React.createElement("div", {
        className: "right"
      }, this.props.actions != null && this.props.actions.length > 0 ? /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: actionTrigger
      }, this.props.actions.map(this.renderAction)) : /*#__PURE__*/React.createElement(Link, {
        to: "/search"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Magnify"
      }))));
    }
  }]);

  return DeviceHeader;
}(Component);

function mapStateToProps(state) {
  return {
    actions: state.Header.actions,
    title: state.Header.title,
    settings: state.Header,
    activeSchool: state.user.activeSchool,
    user: state.user.currentUser,
    userUnread: state.Notifications.userUnread
  };
}

export default withRouter(connect(mapStateToProps, {
  setActiveSchool: setActiveSchool
})(DeviceHeader));